import { IconButton, Tooltip, IconButtonProps } from '@bb-ui/react-library';
import * as React from 'react';

export interface TooltipIconButtonProps extends IconButtonProps {
  label: string;
}

// This pairs an IconButton with a Tooltip.

export const TooltipIconButton: React.FC<TooltipIconButtonProps> = (props) => {
  const { label, ...other } = props;

  return (
    <Tooltip title={label} isCustomTitle placement="top">
      <IconButton aria-label={label} {...other} />
    </Tooltip>
  );
};
